import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ComponentFactoryResolver, ElementRef, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Actions } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { KeycloakService } from "keycloak-angular";
import { DataStore } from "../core/models/data-store";
import { AgenticAiService } from "../core/services/agentic-ai.service";
import { AIStreamingService } from "../core/services/ai-streaming.service";
import { AutomaticScriptTreeService } from "../core/services/automatic-script/automatic-script-tree.service";
import { BreadcrumbService } from "../core/services/breadcrumb.service";
import { ConfigService } from "../core/services/config/config.service";
import { AuthRealmService } from "../core/services/keycloak/auth-realm.service";
import { ProjectService } from "../core/services/project/project.service";
import { RestService } from "../core/services/rest.service";
import { ScriptEditorControlsService } from "../core/services/script-editor-controls.service";
import { SideNavService } from "../core/services/side-nav/side-nav.service";
import { TdgService } from "../core/services/tdg.service";
import { ToasterService } from "../core/services/toaster-service";
import { UtilitiesService } from "../core/services/utilities.service";

/**
 * The base layout component that manages essential services and utilities for the layout structure.
 * It is responsible for providing shared functionality, such as routing, data management,
 * and navigation services to child components.
 */ @Component({
  selector: "app-base-layout",
  standalone: true,
  imports: [],
  templateUrl: "./base-layout.component.html",
  styleUrl: "./base-layout.component.scss",
})
export class BaseLayoutComponent {
  private readonly _blfConfigSvc = inject(ConfigService);

  /** Application base path (e.g. `/` or `/assure/`). Use to build asset URLs. */
  get basePath(): string {
    return this._blfConfigSvc.getApplicationBasePath();
  }

  /** Resolve a static asset path with APPLICATION_BASE_PATH. */
  assetUrl(assetPath: string | null | undefined): string {
    return this._blfConfigSvc.buildAssetUrl(assetPath);
  }

  /** Build an absolute in-app URL including origin and APPLICATION_BASE_PATH. */
  buildAppUrl(route: string = ""): string {
    return this._blfConfigSvc.buildAppUrl(route);
  }

  dataStore!: DataStore;
  activeNode: any;

  /**
   * Constructor to inject required services into the component.
   *
   * @param {UtilitiesService} utilityService - Provides utility methods for various tasks across the app.
   * @param {Store} store - The store used for managing application state.
   * @param {BreadcrumbService} breadcrumbService - Manages breadcrumb navigation in the layout.
   * @param {RestService} restService - Handles HTTP requests for REST API communication.
   * @param {ScriptEditorControlsService} scriptEditorControlsService - Provides controls for the script editor.
   * @param {ChangeDetectorRef} cdr - Reference to the change detector for manual change detection.
   * @param {Router} router - Handles the navigation between different routes in the application.
   * @param {SideNavService} sideNav - Manages the behavior and visibility of the side navigation menu.
   * @param {ProjectService} projectService - Manages project-related data and operations.
   * @param {ActivatedRoute} route - Provides access to the current route information for the component.
   */
  constructor(
    public utilityService: UtilitiesService,
    public store: Store,
    public breadcrumbService: BreadcrumbService,
    public restService: RestService,
    public scriptEditorControlsService: ScriptEditorControlsService,
    public cdr: ChangeDetectorRef,
    public router: Router,
    public sideNav: SideNavService,
    public projectService: ProjectService,
    public route: ActivatedRoute,
    public componentFactoryResolver: ComponentFactoryResolver,
    public automatiCScriptService:  AutomaticScriptTreeService,
    public eRef: ElementRef,
    public actions$: Actions,
    public keycloakService: KeycloakService,
    public toaster: ToasterService,
    public datePipe: DatePipe,
    public tdgService: TdgService,
    public aiStreamingService: AIStreamingService,
    public agenticAiService :AgenticAiService,
    public authRealmService: AuthRealmService
    
  ) {}
}
